import { HTMLAttributes } from 'react';
import styles from './styleConstants.module.css';

export { H2Large } from '../../home/styleConstants';

const cx = (base: string, incoming?: string) =>
  incoming ? `${base} ${incoming}` : base;

export const H1 = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={cx(styles.h1, className)} {...props} />
);

export const H2 = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={cx(styles.h2, className)} {...props} />
);

export const titleH = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={cx(styles.titleH, className)} {...props} />
);

export const H3 = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => (
  <h3 className={cx(styles.h3, className)} {...props} />
);

export const FadeInText = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div className={cx(styles.fadeInText, className)} {...props} />
);
